import React from 'react';

import { useAddDriverButtonPresenter } from './AddDriverButton.presenter';
import * as S from './AddDriverButton.styles';

export const AddDriverButton = ({ onClick, position = 'center', ...rest }) => {
  const presenter = useAddDriverButtonPresenter({ onClick });

  return (
    <S.AddDriverButton
      {...rest}
      disabled={presenter.disabled}
      position={position}
      onClick={presenter.onClick}
    >
      Водитель
    </S.AddDriverButton>
  );
};
